const Rakam = resolve => {
    require.ensure(['../views/apps/rakam/Rakam'], () => {
        resolve(require('../views/apps/rakam/Rakam'))
    })
};
const RakamDetay = resolve => {
    require.ensure(['../views/apps/rakam/RakamDetay'], () => {
        resolve(require('../views/apps/rakam/RakamDetay'))
    })
};
const RakamlarIslem = resolve => {
    require.ensure(['../views/apps/rakam/RakamlarIslem'], () => {
        resolve(require('../views/apps/rakam/RakamlarIslem'))
    })
};

import Vue from 'vue'
Vue.component('RakamDetay', RakamDetay);
Vue.component('Rakamlar', RakamlarIslem);

import layouts from '../layout'

export default {
    path: '/rakam',
    name: 'rakam',
    component: Rakam,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'rakamdetay',
            component: RakamDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
